import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Trash2 } from "lucide-react";

export default function Leads() {
  const qc = useQueryClient();
  const { data: leads = [] } = useQuery({ queryKey: ["admin-leads"], queryFn: async () => (await api.get("/admin/leads")).data });
  const del = useMutation({
    mutationFn: async (id) => (await api.delete(`/admin/leads/${id}`)).data,
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["admin-leads"] }); toast.success("Lead dihapus"); },
  });

  return (
    <div data-testid="admin-leads">
      <h1 className="font-display font-black tracking-tightest text-3xl md:text-4xl mb-2">Leads</h1>
      <p className="text-sm text-muted-foreground mb-8">{leads.length} lead masuk dari form kontak.</p>
      <div className="space-y-4">
        {leads.map((l) => (
          <div key={l.id} className="border border-border p-5" data-testid="lead-item">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h3 className="font-display font-bold text-lg">{l.name} {l.business && <span className="text-muted-foreground font-normal text-sm">— {l.business}</span>}</h3>
                <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm text-muted-foreground mt-1">
                  {l.email && <span>{l.email}</span>}{l.whatsapp && <span>{l.whatsapp}</span>}
                  {l.service && <span className="overline text-[9px]">{l.service}</span>}{l.budget && <span>{l.budget}</span>}
                </div>
                {l.message && <p className="text-sm mt-3 border-l-2 border-border pl-3">{l.message}</p>}
                {l.utm && Object.keys(l.utm).length > 0 && <p className="overline text-[9px] text-muted-foreground mt-3">{Object.entries(l.utm).map(([k, v]) => `${k}=${v}`).join(" · ")}</p>}
                <p className="overline text-[9px] text-muted-foreground/70 mt-2">{new Date(l.created_at).toLocaleString("id-ID")}</p>
              </div>
              <button onClick={() => { if (window.confirm("Hapus lead ini?")) del.mutate(l.id); }} className="p-2 hover:bg-destructive hover:text-destructive-foreground shrink-0"><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
        {leads.length === 0 && <p className="text-center text-sm text-muted-foreground py-16 border border-border">Belum ada lead masuk.</p>}
      </div>
    </div>
  );
}
